export default "__VITE_ASSET__Du7ah1he__"